module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Tomb-Raider.2c03f7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Tomb-Raider.jpg
// module id = 8O8v
// module chunks = 0